import { createSelector } from 'reselect';

const selectAllRatings = state => state.ratings.items || [];

const selectRatingsByWriterId = userId => createSelector(
  selectAllRatings,
  ratings => ratings.filter(rating => rating.writerOnDOR?.id === userId) || [],
);

const selectRequestStatus = state => state.ratings.status;

export default {
  selectAllRatings,
  selectRatingsByWriterId,
  selectRequestStatus,
};
